import { useQuery } from '@tanstack/react-query';

import apiClient from '../../lib/api-client';

export interface MyAdvisors {
  role: 'vp' | 'admin';
  salesTeamIds: string[];
  salesTeamNames: string[];
}

export const myAdvisorsKey = ['advisors', 'mine'] as const;

export function useMyAdvisors() {
  return useQuery({
    queryKey: myAdvisorsKey,
    queryFn: async (): Promise<MyAdvisors> => {
      const { data } = await apiClient.get<MyAdvisors>('/advisors/mine');
      return data;
    },
    staleTime: 5 * 60 * 1000,
  });
}
